export const canImportWorkoutExercises = ({
  existingCount,
  incomingCount,
  maxExercises,
}) => {
  const safeExistingCount =
    typeof existingCount === "number" && Number.isFinite(existingCount)
      ? Math.max(0, existingCount)
      : 0;
  const safeIncomingCount =
    typeof incomingCount === "number" && Number.isFinite(incomingCount)
      ? Math.max(0, incomingCount)
      : 0;
  const safeMaxExercises =
    typeof maxExercises === "number" && Number.isFinite(maxExercises)
      ? Math.max(0, maxExercises)
      : 0;

  return safeExistingCount + safeIncomingCount <= safeMaxExercises;
};
